/**
 * Department entity constants
 */

export const MAX_DEPARTMENT_CODE_LENGTH = 50;
